let infiniteScrollObserver = null;
let isLoadingInfiniteScroll = false;

function setupInfiniteScrollObserver(shopifySection) {
  if (infiniteScrollObserver) {
    infiniteScrollObserver.disconnect();
    infiniteScrollObserver = null;
  }

  const productList = shopifySection.querySelector('.product-list--infinite-scroll');
  if (!productList) return;

  const nextFacetLink = shopifySection.querySelector('nav.pagination[data-type="next"] facet-link');
  if (!nextFacetLink) return;
  const lastItem = productList.lastElementChild;
  if (!lastItem) return;

  const loader = shopifySection.querySelector('.infinite-scroll-loader');

  infiniteScrollObserver = new IntersectionObserver(
    (entries) => {
      if (!entries[0].isIntersecting || isLoadingInfiniteScroll) return;
      const trigger = shopifySection.querySelector('nav.pagination[data-type="next"] facet-link');
      if (!trigger) return;
      isLoadingInfiniteScroll = true;
      infiniteScrollObserver.disconnect();
      infiniteScrollObserver = null;
      if (loader) loader.removeAttribute('hidden');
      trigger.querySelector('a')?.click();
    },
    { rootMargin: '0px 0px -100px 0px' },
  );

  infiniteScrollObserver.observe(lastItem);
}

document.addEventListener('collection:load-products', () => {
  isLoadingInfiniteScroll = false;
  document.querySelectorAll('.shopify-section--main-collection, .shopify-section--main-search').forEach((section) => {
    const loader = section.querySelector('.infinite-scroll-loader');
    if (loader) loader.setAttribute('hidden', '');
    setupInfiniteScrollObserver(section);
  });
});

document.querySelectorAll('.shopify-section--main-collection, .shopify-section--main-search').forEach(setupInfiniteScrollObserver);
